import qs from 'qs';
import request from '../../../lib/request';
import { API } from '../../../constants';

const create = (content) =>
  request({
    url: API.PROCESSO_IMPRESA,
    method: 'POST',
    data: content,
  });

const getAll = (searchFields, page, orderField, orderDirection) =>
  request({
    url: API.PROCESSO_IMPRESA,
    method: 'GET',
    params: {
      pagination: 'alt',
      page: page || 1,
      filter: [
        {
          type: 'search_impresa',
          fieldsvalues: {
            ...searchFields,
          },
        },
      ],
      'order-by': [
        {
          type: 'field',
          field: orderField || 'updatedAt',
          direction: orderDirection !== 'none' ? orderDirection : 'desc',
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const get = (id) =>
  request({
    url: `${API.PROCESSO_IMPRESA}/${id}`,
    method: 'GET',
  });

const put = (content) =>
  request({
    url: `${API.PROCESSO_IMPRESA}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const patchImpresa = (content, impresaId) =>
  request({
    url: `${API.PROCESSO_IMPRESA}/${impresaId}`,
    method: 'PATCH',
    data: content,
  });

const del = (id) =>
  request({
    url: `${API.PROCESSO_IMPRESA}/${id}`,
    method: 'DELETE',
  });

const setToChiusa = (impresaId) =>
  request({
    url: `${API.PROCESSO_IMPRESA}/${impresaId}`,
    method: 'PATCH',
    data: {
      stato: 'chiusa',
    },
  });

const ImpresaService = {
  getAll,
  get,
  put,
  patchImpresa,
  del,
  create,
  setToChiusa,
};

export default ImpresaService;



// WEBPACK FOOTER //
// ./app/shared/services/api/impresa/index.js